export default "__VITE_PUBLIC_ASSET__b69b7812__"